import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import { Subject } from 'rxjs';
import runtime from 'system-runtime';


//import { parsePhoneNumberFromString as parsePhoneNumber } from 'libphonenumber-js';
import parsePhoneNumber from 'libphonenumber-js'
import { botContext } from './stores/botContext';

console.log("Time Check Create Pinia : ", new Date().getTime());
const pinia = createPinia();
console.log("Time Check Created Pinia : ", new Date().getTime());
window.botStore = botContext(pinia);
//console.log("BotStore Loaded => ", window.botStore);
//window.BotServices = createApp(App).use(createPinia()).mount('#_FFFFFFFFFFFFFF00001651912466881253_')
console.log("Time Check Create BotApp : ", new Date().getTime());
window.BotServices = createApp(App).use(pinia).mount('#_FFFFFFFFFFFFFF00001651912466881253_')
console.log("Time Check Created BotApp : ", new Date().getTime());
window.BotServices.Events = new Subject();
import { ReplaySubject } from 'rxjs';
window.BotServices.EventsQueue = new ReplaySubject(10);
const EventsHandler = new Event('EventsHandler');
window.dispatchEvent(EventsHandler);
window.BotServices.PageState = new Subject();
import { ruleEvents } from './modules/rules'
window.BotServices.ruleEvents = ruleEvents;
window.BotServices.rxjs = { Subject : Subject };
window.BotServices.parsePhoneNumber = parsePhoneNumber;
window.runtime = runtime;
import BotEvents from './modules/botEvents';
const botEvents = new BotEvents();
botEvents.init();
//window.BotServices.StreamEvents = new Subject();
window.BotServices.botLogs("Bot Services Loaded");
console.log("botServicesLoaded : ");
const botServicesLoaded = new Event('botServicesLoaded');
window.dispatchEvent(botServicesLoaded);

